import styles from "./Wordmark.module.css";

interface Props {
  /** Nav-sized rather than hero-sized. */
  compact?: boolean;
  /** §04: the tagline is part of mark A, but drop it where space is tight. */
  showTagline?: boolean;
}

/** §04 Logo A — Speedline Wordmark. Primary mark; hero and nav. */
export function Wordmark({ compact = false, showTagline = true }: Props) {
  return (
    <span className={`${styles.mark} ${compact ? styles.compact : ""}`}>
      <span className={styles.bars} aria-hidden="true">
        <span className={`${styles.bar} ${styles.barViolet}`} />
        <span className={`${styles.bar} ${styles.barCyan}`} />
      </span>
      <span className={styles.kev}>KEV</span>
      {showTagline && <span className={styles.tagline}>Your Sharpest Mate</span>}
    </span>
  );
}
